const Error = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        backgroundColor: "#f8f9fa",
        color: "#333",
        padding: "20px",
      }}
    >
      <h1 style={{ fontSize: "80px", margin: "0", color: "#dc3545" }}>
        {"404"}
      </h1>
      <h2 style={{ fontSize: "24px", margin: "10px 0" }}>
        {"Oops! The page you're looking for doesn't exist."}
      </h2>
      <p style={{ fontSize: "16px", color: "#555" }}>
        The page might have been removed, or the URL might be incorrect.
      </p>
      <a
        href="/"
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "#fff",
          textDecoration: "none",
          borderRadius: "4px",
          fontWeight: "bold",
        }}
      >
        Go Back Home
      </a>
    </div>
  );
};

export default Error;
